'use client'

import { useCallback } from 'react'
import { Button } from '@/components/button'
import { SvgOutlinedArrowRight } from '@/icons/svg-outlined-arrow-right'
import { MobileBackButtonType } from '@/setup/back-button-init'
import { useRouter } from '@/setup/i18n/use-router'
import { ILinkParams, IUrlPattern } from '@/setup/routing'
import { cn } from '@/utils/styles/cn'
import { COLORS } from '@/utils/styles/colors'

interface IMobileBackButtonProps<T extends IUrlPattern> {
    className?: string
    href: ILinkParams<T>
    type?: MobileBackButtonType
}

export const MobileBackButton = <T extends IUrlPattern>({
    className,
    href,
    type,
}: IMobileBackButtonProps<T>) => {
    const router = useRouter()

    const onClick = useCallback(() => {
        if (!type) return router.push(href)

        const sessionStorageEntry = window.sessionStorage.getItem(type)

        if (sessionStorageEntry) {
            router.back()
        } else {
            router.push(href)
        }
    }, [router, type, href])

    return (
        <div
            className={cn(
                'md:hidden shadow-custom focus:outline-hidden webkit-tap-transparent rounded-full',
                className
            )}
        >
            <Button onClick={onClick} styleType="secondary" shape="circle" backgroundColor="white">
                <SvgOutlinedArrowRight
                    color={COLORS.trueBlack}
                    size={24}
                    style={{ rotate: '180deg' }}
                />
            </Button>
        </div>
    )
}
